import AuthedHeader from '@/components/headers/AuthedHeader.vue'
import AuthUserAccount from '@/views/auth-user/account/index.vue'
import AuthUserAddresses from '@/views/auth-user/addresses/index.vue'
import AuthUserNotificationSettings from '@/views/auth-user/notification-settings/index.vue'
import AuthUserChangePassword from '@/views/auth-user/change-password/index.vue'
import AuthUserChangeUsername from '@/views/auth-user/change-username/index.vue'
import AuthUserLoginSecurity from '@/views/auth-user/login-security/index.vue'
import AuthUserLoginHistory from '@/views/auth-user/login-security/LoginHistory.vue'
import AuthUserTwoStep from '@/views/auth-user/login-security/TwoStepVerification/index.vue'
import AuthUserPreferences from '@/views/auth-user/user-preferences/index.vue'
import AuthUserProfile from '@/views/auth-user/user-profile/index.vue'
import AuthUserDeactivateAccount from '@/views/auth-user/deactivate-account/index.vue'

export default [
  {
    path: '/user-profile',
    name: 'AuthUserProfile',
    meta: { needsAuth: true },
    components: {
      default: AuthUserProfile,
      navbar: AuthedHeader
    }
  },
  {
    path: '/notification-settings',
    name: 'AuthUserNotificationSettings',
    meta: { needsAuth: true },
    components: {
      default: AuthUserNotificationSettings,
      navbar: AuthedHeader
    }
  },
  {
    path: '/change-password',
    name: 'AuthUserChangePassword',
    meta: { needsAuth: true },
    components: {
      default: AuthUserChangePassword,
      navbar: AuthedHeader
    }
  },
  {
    path: '/change-username',
    name: 'AuthUserChangeUsername',
    meta: { needsAuth: true },
    components: {
      default: AuthUserChangeUsername,
      navbar: AuthedHeader
    }
  },
  {
    path: '/user-preferences',
    name: 'AuthUserPreferences',
    meta: { needsAuth: true },
    components: {
      default: AuthUserPreferences,
      navbar: AuthedHeader
    }
  },
  {
    path: '/login-and-security',
    meta: { needsAuth: true },
    components: {
      default: AuthUserLoginSecurity,
      navbar: AuthedHeader
    },
    children: [
      {
        path: '',
        name: 'AuthUserLoginSecurity',
        redirect: '/login-and-security/history'
      },
      {
        path: 'history',
        name: 'AuthUserLoginHistory',
        component: AuthUserLoginHistory
      },
      {
        path: 'two-step',
        name: 'AuthUserTwoStep',
        component: AuthUserTwoStep
      }
    ]
  },
  {
    path: '/your-account',
    name: 'AuthUserAccount',
    meta: { needsAuth: true },
    components: {
      default: AuthUserAccount,
      navbar: AuthedHeader
    }
  },
  {
    path: '/addresses',
    name: 'AuthUserAddresses',
    meta: { needsAuth: true },
    components: {
      default: AuthUserAddresses,
      navbar: AuthedHeader
    }
  },
  {
    path: '/deactivate-account',
    name: 'AuthUserDeactivateAccount',
    meta: { needsAuth: true },
    components: {
      default: AuthUserDeactivateAccount,
      navbar: AuthedHeader
    }
  }
]
